<template>
  <div
    class="User User--detail flex-shrink-0"
    @click="triggerFileInput"
  >
    <div class="user-profile">

      <i
        class="camera"
        aria-hidden="true"
      ></i>
      <img
        id="avatar"
        :src="avatar"
        class="profile-picture"
        :class="imageClass"
        alt="user avatar"
        v-if="avatar"
      >
      <div class="Thumb Thumb--72 bg-secondary text-white"> {{userName | extractInitialsByName}}</div>
    </div>
    <input
      type="file"
      ref="inputfile"
      @change="setFile"
      name="file"
      accept="'image/jpeg,image/jpg,image/png,image/x-png'"
      id="file"
      class="input--file"
    >

  </div>
</template>

<script>
import { getResourceFromAws } from '@/shared/_api'
export default {
  name: 'UserAvatarUploader',
  props: {
    profilePictureId: {
      type: Number
    },
    userName: {
      type: String
    },
    imageClass: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showInputFileFlag: false,
      file: null,
      avatar: ''
    }
  },
  methods: {
    setFile (event) {
      this.file = null
      this.file = event.target.files[0]
      this.$emit('avatarChange', this.file)
      this.avatar = URL.createObjectURL(this.file)
    },
    triggerFileInput () {
      this.$refs.inputfile.click()
    },
    async getProfilePicture () {
      if (this.profilePictureId) {
        // const userPictureUrl = await getMediaUrl(this.profilePictureId)
        const userPicture = await getResourceFromAws(this.profilePictureId)

        this.avatar = URL.createObjectURL(userPicture.data)
      } else {
        this.avatar = null
      }
    },
    destroyed () {
      this.avatar = null
    }
  },
  watch: {
    profilePictureId: {
      handler: 'getProfilePicture',
      immediate: true
    }
  }

}
</script>

<style scoped>
.User {
  background-color: var(--fill-background);
}
.camera {
  background-image: url("~@/assets/img/camera.png");
  background-repeat: no-repeat;
  background-size: contain;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 24px;
  left: 24px;
  visibility: hidden;
}
.profile-picture {
  height: 100%;
  width: 100%;
  max-height: 72px;
  min-height: 72px;
}
.user-profile:hover .camera {
  display: block;
  visibility: visible;
  opacity: 0.8;
}
.user-profile {
  min-width: 72px;
  height: 72px;

  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: var(--fill-background);
}
.input--file {
  width: 0px;
  height: 0px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
</style>
